
import { getRequest } from '@/axios/Api'
import { Delete, Edit, Search, Plus, Message } from '@element-plus/icons-vue'
import { defineComponent, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { IAboutUs } from './interfaces/IEntity'
import { IResp } from './interfaces/IResp'

export default defineComponent({
  setup() {
    const aboutUs = ref<IAboutUs>()
    const mailHref = ref('')
    const isMobile = ref(typeof window !== 'undefined' && window.innerWidth < 768)
    const menuOpen = ref(false)
    const route = useRoute()

    const checkMobile = () => {
      isMobile.value = window.innerWidth < 768
      if (!isMobile.value) {
        menuOpen.value = false
      }
    }

    watch(
      () => route.path,
      () => {
        menuOpen.value = false
      }
    )

    onMounted(() => {
      checkMobile()
      window.addEventListener('resize', checkMobile)
      getRequest<void>('/AboutUs/newest').then((response) => {
        if (response) {
          console.log(response)
          let resp = response as IResp<IAboutUs>
          aboutUs.value = resp.obj
          mailHref.value = 'mailto:' + resp.obj.email
        }
      })
    })

    onUnmounted(() => {
      window.removeEventListener('resize', checkMobile)
    })

    return {
      Delete,
      Edit,
      Search,
      Plus,
      Message,
      aboutUs,
      mailHref,
      isMobile,
      menuOpen,
    }
  },
})
